import { MenuItem, Select } from '@mui/material'
import type { HTMLAttributes } from 'react'
import { cn } from '../../../utils/cn.utils'
import type { PERIOD_TYPE } from '../../../lib/apis/dtos/request/quotation.request'

interface PeriodSelectProps {
  value: PERIOD_TYPE | null | undefined
  onChange: (value: PERIOD_TYPE) => void
  className?: string
  errorField?: string
}

export const PeriodSelect = ({
  value,
  onChange,
  className,
  errorField,
}: PeriodSelectProps) => {
  return (
    <Select
      className={cn('w-full text-[11px]', className)}
      disableUnderline
      SelectDisplayProps={
        {
          'data-error-field': errorField,
          'data-error-value': value ?? '',
        } as HTMLAttributes<HTMLDivElement>
      }
      MenuProps={{
        disablePortal: true,
        MenuListProps: {
          disablePadding: true,
          onMouseDown: (e) => e.stopPropagation(),
        },
      }}
      sx={{
        height: '40px',
        fontSize: '11px',
        fontWeight: 'medium',
        '& fieldset': {
          border: 'none',
        },
        '& .MuiSelect-select': {
          paddingY: '8px !important',
          paddingX: '12px !important',
          display: 'flex',
          alignItems: 'center',
        },
        '& .MuiSelect-icon': {
          right: '4px',
        },
      }}
      variant="outlined"
      value={value}
      onMouseDown={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      onChange={(e) => {
        onChange(e.target.value as PERIOD_TYPE)
      }}
    >
      <MenuItem
        sx={{
          fontSize: '11px',
          fontWeight: 'medium',
          paddingX: '12px',
          paddingY: '8px',
        }}
        value={'M_PLUS_N'}
      >
        {'잔여일+개월'}
      </MenuItem>
      <MenuItem
        sx={{
          fontSize: '11px',
          fontWeight: 'medium',
          paddingX: '12px',
          paddingY: '8px',
        }}
        value={'MONTH'}
      >
        {'개월'}
      </MenuItem>
      <MenuItem
        sx={{
          fontSize: '11px',
          fontWeight: 'medium',
          paddingX: '12px',
          paddingY: '8px',
        }}
        value={'DAY'}
      >
        일
      </MenuItem>
    </Select>
  )
}
